export function splitDateTime(dateTimeString) {
    const [date, time] = dateTimeString.split("T");
    return { date, time: time.split(".")[0] }; // Removing milliseconds
}